import config from "../config";
import request from "./httpService";

const { apiHost, backendBaseURL } = config().secrets;

export async function getCountry() {
	const { data } = await request.get(`${apiHost}/api/getCountry`);
	return data;
}

export async function getState(countryID) {
	const { data } = await request.get(
		`${apiHost}/api/getState?countryID=${countryID}`
	);
	return data;
}

export async function getCity(stateId) {
	const { data } = await request.get(
		`${apiHost}/api/getCity?stateID=${stateId}`
	);
	return data;
}

export async function getDocUrl(payload) {
	const url = `${apiHost}/api/registrars/CSRLKYCImageSubmit_`;
	const { data } = await request.post(url, payload);
	return data;
}

export async function kycSubmission(payload) {
	const url = `${backendBaseURL}/api/v1/user/kycSubmission`;
	const { data } = await request.post(url, payload);
	return data;
}
